<template>
  <div class="stk-py-6">
    <TaskIndex
      title="Active Tasks"
      status="accepted"
    />
  </div>
</template>

<script>
import TaskIndex from '@frontend/ui/features/tasks/components/tasks/TaskIndex.vue';

export default {
  name: 'ActionCenterTasksView',
  components: {
    TaskIndex,
  },
};
</script>
